import { render, staticRenderFns } from "./DialogUpdateEducationPrograms.vue?vue&type=template&id=495e7b16"
import script from "./DialogUpdateEducationPrograms.vue?vue&type=script&lang=js"
export * from "./DialogUpdateEducationPrograms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports